<template>
  <div id="contenedor-mapas-default">
    <v-container fluid>
        <v-card
          flat>
          <Mapa
            :marcadores="getMarcadores"
            :lineas="getLineas"/>
        </v-card>
    </v-container>
      <v-navigation-drawer
        v-if="mostrarDetallesContrato && idContratoDetalles"
        v-model="mostrarDetallesContrato"
        absolute
        right
        width="500">
        <v-card-text>
          <detalles-contrato
            :id-contrato="idContratoDetalles">
          </detalles-contrato>
        </v-card-text>
      </v-navigation-drawer>
      <v-dialog
        v-if="mostrarVentanaImagenes"
        v-model="mostrarVentanaImagenes"
        width="50%"
        heigth= "30%">
        <v-card>
          <imagen-carousels
          :imagenes="imagenesMostrar"
          :currentIndex="indexImagenMostrar">
          </imagen-carousels>
        </v-card>

      </v-dialog>

  </div>
</template>

<script>
import CONTRATOS_UBICACIONES from '@/graphql/querys/administracion/contratos/ubicaciones/contratosUbicaciones.gql';
import Mapa from '@/components/maps/Mapa.vue';
import DetallesContrato from '@/components/administracion/contratos/contrato/detalles/Main.vue';
import ImagenCarousels from '@/components/ImagenCarousels.vue';
import eventBus from '@/helpers/eventBus';

const baseURL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  name: 'MapasDefault',
  components: {
    Mapa,
    DetallesContrato,
    ImagenCarousels,
  },
  data() {
    return {
      mostrarDetallesContrato: false,
      mostrarVentanaImagenes: false,
      imagenesMostrar: [],
      indexImagenMostrar: 0,
      idContratoDetalles: null,
    };
  },
  methods: {
    cerrarVentanaImagenes() {
      this.imagenesMostrar = [];
      this.indexImagenMostrar = 0;
      this.mostrarVentanaImagenes = false;
    },
  },
  mounted() {
    eventBus.$on('details', (idContrato) => {
      this.mostrarDetallesContrato = true;
      this.idContratoDetalles = idContrato;
    });
    eventBus.$on('verImagen', (imagenes) => {
      this.imagenesMostrar = imagenes.imagenesParaVer.map((imagen) => `${baseURL}/${imagen}`);
      this.indexImagenMostrar = imagenes.indexImagenVer;
      this.mostrarVentanaImagenes = true;
    });
    eventBus.$on('cerrarPanelDetalles', () => {
      this.mostrarDetallesContrato = false;
    });
  },
  apollo: {
    contratosUbicaciones: {
      query: CONTRATOS_UBICACIONES,
    },
  },
  computed: {
    getMarcadores() {
      if (!this.contratosUbicaciones) return [];
      return this.contratosUbicaciones
        .filter((ubicacion) => ubicacion.latitudPuntoB === '')
        .map(({
          id, latitudPuntoA, longitudPuntoA, idContrato, contrato,
        }) => ({
          id,
          idReference: idContrato,
          posicion: {
            lat: parseFloat(latitudPuntoA),
            lng: parseFloat(longitudPuntoA),
          },
          titulo: contrato.numero,
        }));
    },
    getLineas() {
      if (!this.contratosUbicaciones) return [];
      return this.contratosUbicaciones
        .filter((ubicacion) => ubicacion.latitudPuntoB !== '')
        .map(({
          id, latitudPuntoA, longitudPuntoA, latitudPuntoB, longitudPuntoB, idContrato,
        }) => ({
          id,
          idReference: idContrato,
          path: [
            {
              lat: parseFloat(latitudPuntoA),
              lng: parseFloat(longitudPuntoA),
            },
            {
              lat: parseFloat(latitudPuntoB),
              lng: parseFloat(longitudPuntoB),
            },
          ],
        }));
    },
  },
};
</script>

<style>

</style>
